<div class="powered-by" aria-label="Powered by Inprovider">
	<span class="powered-by__label">Powered by</span>
	<img
		class="powered-by__logo"
		[src]="logoSrc"
		alt="Inprovider"
		loading="lazy"
		decoding="async" />
</div>
